import { ChatbotFeatureFlags } from 'models/api/chatbot-feature-flags-model';
import { handleActions } from 'redux-actions';

import {
  chatBotFeatureFlagsError,
  chatBotFeatureFlagsLoaded,
  chatBotFeatureFlagsLoading,
} from 'store/actions/statement-content-actions';

export default handleActions(
  {
    [chatBotFeatureFlagsLoading]: (chatbotFeatureFlags) => {
      return chatbotFeatureFlags.setLoading();
    },
    [chatBotFeatureFlagsLoaded]: (chatbotFeatureFlags, { payload }) => {
      return chatbotFeatureFlags.setLoaded(payload);
    },
    [chatBotFeatureFlagsError]: (chatbotFeatureFlags, { payload }) => {
      return chatbotFeatureFlags.setError(payload);
    },
  },
  new ChatbotFeatureFlags(),
);
